import { InputType } from 'config'
import { DateTime } from 'luxon'
import { capitalizeFirstLetter, fillObject } from 'utils'

export const defaultInputs = (): Record<string, Record<string, InputType>> => {
  const weeklyLoanReport: Record<string, InputType> = {
    section1: {
      inputType: 'section',
      title: 'Weekly Loan Report',
      span: 'full',
    },
    enabled: {
      inputType: 'togglebutton',
      title: 'Enable Weekly Loan Report',
      span: 'full',
    },
    time: {
      inputType: 'text',
      type: 'time',
      title: 'Time',
      required: true,
    },
    weekday: {
      inputType: 'select',
      title: 'Week day',
      options: fillObject(Object.keys(Array(7).fill(1)), (v: any) =>
        DateTime.local()
          .startOf('week')
          .plus({ days: Number(v - 1) })
          .toFormat('cccc'),
      ),
      hasDefaultOption: true,
      required: true,
    },
    subject: {
      inputType: 'text',
      title: 'Subject',
      required: true,
      span: 'full',
    },
  }

  ;['loanOfficer', 'creator', 'loanProcessor', 'underwriter', 'accountExecutive', 'broker', 'assignedUser'].forEach(
    (accountType) => {
      weeklyLoanReport[accountType] = {
        inputType: 'text',
        title: capitalizeFirstLetter(accountType),
        span: 'full',
      }
    },
  )

  return {
    weeklyLoanReport,
  }
}
